import React from 'react';
// import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import BasePage from 'components/BasePage';
import { FlexColContainer } from 'components/StyledComp';
import Panel from 'components-desktop/Panel';
import CaregiverDetails from './components/profile/CaregiverDetails';
import CaregiverSickLeaves from './components/profile/CaregiverSickLeaves';
import CaregiverCalendar from './components/profile/CaregiverCalendar';
import CaregiverEfiles from './components/profile/CaregiverEfiles';

const propTypes = {
};

@autobind
class CaregiverProfilePage extends BasePage {
  constructor(props) {
    super(props);

    this.state = {
      caregiver: null,
      tabsActiveKey: props.location.hash?.substring(1) || 'details',
    };
  }

  componentDidMount() {
    this.id = this.parseQueryParam('id', this.props.location);
    this.getCaregiver();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.location !== prevProps.location) {
      this.setState({
        tabsActiveKey: this.props.location.hash?.substring(1) || 'details',
      });
    }
  }

  getTitle() {
    return 'Caregiver Profile';
  }

  async getCaregiver() {
    const params = { id: this.id };
    const caregiver = await this.callServiceForRemoteObject('/caregiver/get_model', params);

    this.setState({
      caregiver,
    });
  }

  isInRenderableState() {
    return !!this.state.caregiver;
  }

  renderContent() {
    const { caregiver, tabsActiveKey } = this.state;

    return (
      <FlexColContainer
        width="match_parent"
        height="wrap_content"
        alignItems="center"
      >
        <Panel
          width="match_parent"
          height="wrap_content"
          margin="0 0 24px 0"
          color="green_haze"
          title={`Caregiver - ${caregiver.getString('fullName')} (${caregiver.getId()})`}
          icon="user-add"
          tabs={['Details', 'Sick Leaves', 'Calendar', 'Efiles']}
          tabsActiveKey={tabsActiveKey}
          tabsOnChange={activeKey => this.setState({ tabsActiveKey: activeKey.substring(2) })}
        >
          <CaregiverDetails
            key="details"
            width="match_parent"
            height="wrap_content"
            caregiver={caregiver}
          />

          <CaregiverSickLeaves
            key="sickLeaves"
            width="match_parent"
            height="wrap_content"
          />

          <CaregiverCalendar
            key="calendar"
            width="match_parent"
            height="wrap_content"
          />

          <CaregiverEfiles
            key="efiles"
            width="match_parent"
            height="wrap_content"
          />
        </Panel>
      </FlexColContainer>
    );
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
CaregiverProfilePage.propTypes = propTypes;

export default CaregiverProfilePage;
